export default __webpack_public_path__ + "images/7a1aea4b41cabde3ee3666cddf095b6c.png";